module.exports = __webpack_public_path__ + "img/task_icon2.84a635f9.png";